module.exports = __webpack_public_path__ + "img/icon-symptom.396742bc.png";